import { useState, useEffect } from "react";
import Lenis from "lenis";
import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { EditorialMarquee } from "../components/site/EditorialMarquee";
import { Services } from "../components/site/Services";
import { Manifesto } from "../components/site/Manifesto";
import { Gallery } from "../components/site/Gallery";
import { Store } from "../components/site/Store";
import { Location } from "../components/site/Location";
import { BookingDialog } from "../components/site/BookingDialog";

export default function Landing() {
  const [booking, setBooking] = useState(false);
  const openBooking = () => setBooking(true);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <div className="App relative">
      <div className="grain-overlay" />
      <Header onBook={openBooking} />
      <main className="pb-24 md:pb-0">
        <Hero onBook={openBooking} />
        <EditorialMarquee />
        <Services onBook={openBooking} />
        <Manifesto />
        <Gallery />
        <Store />
        <Location onBook={openBooking} />
      </main>
      <BookingDialog open={booking} onOpenChange={setBooking} />

      <button
        onClick={openBooking}
        data-testid="mobile-sticky-book"
        className="md:hidden fixed bottom-4 inset-x-4 z-40 py-4 bg-[#C9A24B] text-black text-xs uppercase tracking-[0.25em] font-semibold rounded-sm shadow-lg shadow-black/40 active:scale-[0.98] transition-transform"
      >
        Book Appointment
      </button>
    </div>
  );
}
